import React, { Component } from "react";
import AnnouncementClient from "../../../shared/clients/AnnouncementClient";
import styles from "./Announcement.module.scss";
import UiDateUtils from "../../../utils/UiDateUtils";
import { withTranslation } from "react-i18next";

class DealerAnnouncement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderApp: false,
      announcement: null,
      showMore: false,
    };
  }

  componentDidMount() {
    this.getAnnouncements();
  }

  setShowMore = () => {
    this.setState((prevState) => ({
      showMore: !prevState.showMore,
    }));
  };

  getAnnouncements = () => {
    AnnouncementClient.getAnnouncements(this.props.user)
      .then((response) => {
        if (response.data[0]) this.setState({ announcement: response.data[0] });
        else this.setState({ announcement: null });
      })
      .catch(() => {
        this.setState({ announcement: null });
      })
      .finally(() => {
        this.setState({ renderApp: true });
      });
  };

  render() {
    return (
      this.state.renderApp && (
        <div>
          {this.state.announcement ? (
            <div className={styles.moduleWrapper}>
              <div className={styles.nscAnnouncementDescription}>
                {this.props.t("Announcement.dealerAnnouncement")} (
                {UiDateUtils.formatYYYYMMDDToEUWithoutTime(
                  this.state.announcement.createdDate
                )}
                )
              </div>
              <div className={styles.announcementDescription}>
                {this.state.showMore
                  ? `${this.state.announcement.announcement}`
                  : `${this.state.announcement.announcement.substring(0, 200)}`}
                {this.state.announcement.announcement.length < 200 ? (
                  ""
                ) : (
                  <>
                    {this.state.showMore ? "" : "..."}

                    <span
                      className={styles.showButton}
                      onClick={() => this.setShowMore()}
                    >
                      <sup>
                        {this.state.showMore ? (
                          <span>{this.props.t("Announcement.showLess")}</span>
                        ) : (
                          <span>{this.props.t("Announcement.showMore")}</span>
                        )}
                      </sup>
                    </span>
                  </>
                )}
              </div>
            </div>
          ) : (
            <div className={styles.spacer} />
          )}
        </div>
      )
    );
  }
}

export default withTranslation("emp")(DealerAnnouncement);
